import { Request } from '../../httpClient/serverApi/requests/Request';
import { IAdminProfileDetails } from '../models/IAdminProfile';

export interface IGetAdminProfileDetailsParams {
  luid: string;
}

export class GetAdminProfileDetailsRequest extends Request<IGetAdminProfileDetailsParams, IAdminProfileDetails> {
  constructor(params: IGetAdminProfileDetailsParams) {
    super('getAdminProfileDetails', params);
  }
}